export const environment = {
	production: true,
	fsRequired: false,
	livePayment: false,
	siteURL: 'https://business-liability-test.herokuapp.com/',
	liveStatus: false,
	cardUrl: 'https://pay.sandbox.realexpayments.com/pay',
	pKey: 'pk_test_51Lt7PdDg0f22q98rkk8mBBZXG1BvSOO7BYIzbOu9LdgoAEGRKNa0u2mH6903bFzBYLag9EADOSTtCacI3RvuJOKR005cqJCOzL'

};
